"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getSkusPrices = getSkusPrices;
var _map2 = _interopRequireDefault(require("lodash/map"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
function getSkusPrices(prices, skus) {
  const skusMap = (0, _keyBy2.default)(skus, 'id');
  return (0, _map2.default)(prices, price => {
    var _skusMap$price$skuId;
    return {
      ...price,
      title: (_skusMap$price$skuId = skusMap[price === null || price === void 0 ? void 0 : price.skuId]) === null || _skusMap$price$skuId === void 0 ? void 0 : _skusMap$price$skuId.title
    };
  });
}